export let rebinSetKey = "rebinSetKey";
export let storeConfluenceSetKey = "storeConfluenceSetKey";
export let packSetKey = "packSetKey";
export let suPackSetKey = "suPackSetKey";
export let equimentTypePacking = "pkMachine";

export let DefaultRebinSet = {
    platformNo: "",
    rows: 3,
    cols: 4,
    enableScanOneByOne: false,
    direction: 1,  //1代表横向，0为纵向
    fontSize: 10,
    platform:""
}

export let DefaultPackSet = {
    platformNo: "",
    checkList : []
}

export let DefaultStoreConfluenceSet = {
    platformNo: "",
    rows: 5,
    cols: 6,
    enableScanOneByOne: false,
    direction: 1,  //1代表横向，0为纵向
    fontSize: 10,
    platform:""
}
